import { useEffect, useState } from 'react';
import { SyncManager, type SyncStatus } from '../lib/sync-manager';

/**
 * Subscribes to the SyncManager singleton and returns the current sync
 * status (`'idle' | 'syncing' | 'error'`). Re-renders whenever the status
 * changes.
 */
export function useSyncStatus(): SyncStatus {
  const [status, setStatus] = useState<SyncStatus>(() =>
    SyncManager.getInstance().getStatus(),
  );

  useEffect(() => {
    const sm = SyncManager.getInstance();
    setStatus(sm.getStatus());
    return sm.onStatusChange(setStatus);
  }, []);

  return status;
}
